const datafiles = require.context('./data', false, /\.js$/)
const modules = {}
datafiles.keys().forEach((key) => {
  let name = key.replace(/(\.\/|\.js)/g, '')
  name = name.charAt(0).toUpperCase() + name.slice(1)
  modules['get' + name] = datafiles(key).default
})
export default modules
